export default __webpack_public_path__ + "static/media/oneway.259f4b95.svg";